<template>
  <KDraggableField class="input-container" v-model="files" :allowedFormats="['pdf', 'xml']">
    <md-avatar class="md-avatar-icon md-primary">
      <md-icon>attachment</md-icon>
    </md-avatar>
    <p class="input-text">{{ uploadLabel }}</p>
  </KDraggableField>
</template>

<script>
import { makeFilesByName } from "./utils";
import KDraggableField from "@/components/Inputs/KDraggableField";

// const filesMimes = ["application/pdf", "text/xml"];

// const filesToMimes = {
//   pdf: "application/pdf",
//   xml: "text/xml",
// };

export default {
  name: "MultipleFileLoad",
  components: {
    KDraggableField,
  },
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    uploadLabel: {
      type: String,
      default: "Subir archivos",
    },
  },

  computed: {
    filesByName() {
      return makeFilesByName(this.files);
    },
  },

  methods: {
    uploadInvoice() {
      this.$emit("uploadInvoice");
    },
    removeFile(filename) {
      const rFiles = this.filesByName[filename] || [];
      for (const file of rFiles) {
        const { files } = this;
        files.splice(files.indexOf(file), 1);
      }
    },
    resetFiles() {
      this.files = [];
    },
  },

  data() {
    return {
      files: [],
    };
  },

  watch: {
    filesByName(value) {
      this.$emit("filesLoaded", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  justify-content: center;
  .md-avatar {
    margin: 0;
    margin-right: 24px;
  }
  .input-text {
    font-weight: 600;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Inputs/FileByTypeLoader.vue